import * as React from 'react';
import { PartitionedPage } from 'ui/add_pangolin/partitioned_page/partitioned_page';
import { Theme, useStyles } from 'ui/base/theme';
import baseStyles from './add_pangolin_power_up.module.css';
import AddPangolinPowerUpMessages from './add_pangolin_power_up_messages';
import { Link } from 'ui/base/link';
import { BasePath } from 'services/base/page_path';
import { ActiveButton } from 'ui/public/button';
import { BackButton } from 'ui/base/button/back_button';
import { PLATFORM } from 'services/base/config';

type AddPangolinPowerUpStyles = {
  title: string;
  instructions: string;
  image: string;
  actions: string;
};

const themedStyles: Record<Theme, AddPangolinPowerUpStyles> = {
  [Theme.DAYLIGHT]: {
    title: baseStyles.daylightTitle,
    instructions: baseStyles.daylightInstructions,
    image: baseStyles.daylightImage,
    actions: baseStyles.actions,
  },
  [Theme.MIDNIGHT]: {
    title: baseStyles.midnightTitle,
    instructions: baseStyles.midnightInstructions,
    image: baseStyles.midnightImage,
    actions: baseStyles.actions,
  },
};

export const AddPangolinPowerUp = () => {
  const styles = useStyles(themedStyles);
  const top = (
    <>
      <BackButton/>
      <div className={styles.title}>
        {AddPangolinPowerUpMessages.title()}
      </div>
      <div className={styles.instructions}>
        {AddPangolinPowerUpMessages.instructions()}
      </div>
    </>
  );
  const middle = <div className={styles.image}/>;
  const bottom = (
    <div className={styles.actions}>
      <Link path={{ kind: PLATFORM === 'web' ? BasePath.ADD_PANGOLIN_MNEMONIC : BasePath.ADD_PANGOLIN_METHOD }}>
        <ActiveButton>
          {AddPangolinPowerUpMessages.next()}
        </ActiveButton>
      </Link>
    </div>
  );
  return (
    <PartitionedPage top={top} middle={middle} bottom={bottom}/>
  );
};
